import { withRouter } from 'react-router-dom';
import Application from './Application';

export default withRouter(Application);
